<template>

  <div class="relative flex flex-col flex-grow w-full glide">
    <div data-glide-el="controls" class="absolute z-10 flex justify-between flex-grow w-full h-full px-10">

      <button data-glide-dir="<" style="outline: 0;">
        <i class="cursor-pointer fas fa-chevron-left"></i>
      </button>

      <button data-glide-dir=">" style="outline: 0;">
        <i class="cursor-pointer fas fa-chevron-right"></i>
      </button>

    </div>

    <div class="flex flex-col flex-grow w-full h-full glide__track" data-glide-el="track">
      <ul class="flex flex-grow w-full h-full glide__slides">
        <li class="flex items-center justify-center flex-grow-0 flex-shrink-0 h-full glide__slide">
          <img
            class="object-cover h-full "
            src="../assets/img/background-logo.png"
            alt=""
          >
        </li>
        <li class="flex items-center justify-center flex-grow-0 flex-shrink-0 h-full glide__slide">
          <img
            class="object-cover h-full "
            src="../assets/img/background-logo.png"
            alt=""
          >
        </li>
        <li class="flex items-center justify-center flex-grow-0 flex-shrink-0 h-full glide__slide">
          <img
            class="object-cover h-full "
            src="../assets/img/background-logo.png"
            alt=""
          >
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import Glide from '@glidejs/glide';

export default {
  mounted() {
    new Glide('.glide', {
      autoplay: 3500,

    }).mount();
  },
};
</script>
